const SoftwareLicenceService = {
  async saveSoftwareLicence(formData) {
    try {
      const profileLogged = JSON.parse(localStorage.getItem('profile'));
      const { accountIdentifier } = profileLogged;
      let url = '/api/software-licence/' + formData.identifier;
      let method = 'PUT';

      if (formData.identifier === undefined) {
        url = '/api/software-licence';
        method = 'POST';
      }
      const updatedData = { ...formData, accountIdentifier, profileIdentifier: profileLogged.identifier }; 
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updatedData)
      });
      if (response.ok) {
        const newSoftwareLicence = await response.json();
        console.log('SoftwareLicence has been updated:', newSoftwareLicence);
      }
    } catch (error) {
      console.log('Error saving SoftwareLicence', error);
    }
  },
  async retrieveAllSoftwareLicenceByAccount() {
    try {
      const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
      console.log(accountIdentifier);
      const response = await fetch('/api/software-licence/account/' + accountIdentifier);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching Software Licence', error);
      throw error;
    }
  },
  async retrieveSoftwareLicence(identifier) {
    try {
      const response = await fetch('/api/software-licence/' + identifier);
      const data = await response.json();

      return data;
    } catch (error) {
      console.error('Error fetching Software Licence', error);
      throw error;
    }
  },
  async deleteSoftwareLicence(identifier) {
    try {
      let url = '/api/software-licence/' + identifier;
      let method = 'DELETE';
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const newSoftwareLicence = await response.json();
        console.log('SoftwareLicence has been deleted:', newSoftwareLicence);
      }
    } catch (error) {
      console.log('Error deleting SoftwareLicence', error);
    }
  }
};
export default SoftwareLicenceService;  